import { setupFormState } from '@/components/form/tidal-form'
import { DriverActivityFormValues } from './types'

export const initialValues: DriverActivityFormValues = {
  collectStartEndRoute: false,
  reasonsForNotCompletedOrders: [],
  enableDynamicLoads: false,
  enableDynamicCustomFields: false,
}

export const form = setupFormState<DriverActivityFormValues>({
  id: 'driver-activity-form',
  initialValues,
})
